<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">Crawl Summary</span>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <p>Feature is coming soon...!</p>
        </template>
      </transition>
    </div>
    <!-- <div class="a-footer">
      <PaginationBar :total="pagin.total" @change="paginChange" />
    </div> -->
  </div>
</template>

<script>
  export default {
    name: 'DomainCrawlSummary',
    data() {
      return {
        isLoading: false,
      };
    },
    methods: {
      elSizeChange() {}
    },
  };
</script>

<style lang="scss" scoped>
</style>
